import React from "react";
import { Redirect } from "react-router-dom";
import { Layout } from "antd";
import Header from "../shared/Header";
import DomainAuditReport from "../auditReport/DomainAuditReport";
import useUrlState from "../../hooks/useUrlState";
import UrlAuditReport from "../auditReport/UrlAuditReport";


const { Content } = Layout;


export default function SeoAuditReportPage() {
    const [urlState] = useUrlState();
    const { w_guid: websiteGuid, url_guid: urlGuid } = urlState;

    const showUrlAnalysis = !!websiteGuid && !!urlGuid;
    const showDomainAnalysis = !!websiteGuid && !urlGuid;
    const redirectToDashboard = !urlGuid && !websiteGuid;

    return (
        <Content className="general-layout-content">
            <Header
                title={`${showUrlAnalysis ? "URL" : "Domain"} analysis report`}
                showRedirectArrow
            />

            {showUrlAnalysis && <UrlAuditReport websiteGuid={websiteGuid} urlGuid={urlGuid} />}
            {showDomainAnalysis && <DomainAuditReport websiteGuid={websiteGuid} />}
            {redirectToDashboard && <Redirect to={{ pathname: "/deep-analysis" }} />}
        </Content>
    );
}
